import styled from "styled-components";

interface IFallbackBackgroundProps {
  backgroundColor: string;
}

export const FallbackBackground = styled.div<IFallbackBackgroundProps>`
  width: 45px;
  height: 25px;

  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const CustomGroupSectionLabelContainer = styled.div`
  @media (max-width: 850px) {
    width: 100%;
  }

  > button {
    font: 600 0.875rem/150% "Inter";
    padding-left: 12px;

    @media (max-width: 850px) {
      display: none;
    }

    svg path {
      stroke: currentColor;
    }
  }

  ${FallbackBackground}, img {
    border-radius: 1.5px;
  }

  .group {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;

    padding: 12px;

    @media (max-width: 850px) {
      margin-top: 0.75rem;
    }

    ::before,
    ::after {
      content: "";

      width: 300px;
      height: 1px;

      background-color: ${({ theme }) => theme.console.sidebar.borderColor};

      position: absolute;

      @media (max-width: 850px) {
        width: 103vw;
      }
    }

    ::after {
      top: 0;
      left: -20px;
    }

    ::before {
      bottom: 0;
      right: -40px;

      @media (max-width: 850px) {
        right: -20px;
      }
    }

    span {
      font: 600 0.875rem/150% "Inter";
      color: ${({ theme }) => theme.console.pageTitleColor};

      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      word-break: break-all;

      text-align: start;
    }
  }
`;
